import { render, staticRenderFns } from "./AcceptAgbsText.vue?vue&type=template&id=6e58561c&scoped=true"
import script from "./AcceptAgbsText.vue?vue&type=script&lang=js"
export * from "./AcceptAgbsText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e58561c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e58561c')) {
      api.createRecord('6e58561c', component.options)
    } else {
      api.reload('6e58561c', component.options)
    }
    module.hot.accept("./AcceptAgbsText.vue?vue&type=template&id=6e58561c&scoped=true", function () {
      api.rerender('6e58561c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AcceptAgbsText.vue"
export default component.exports